<template>
	<page>
		<module enable-flex ref="view">
			<m-search ref="search" @search="searchHandle">
				<c-form>
					<c-form-item type="input" label="结算流水号" name="record_number"></c-form-item>
					<c-form-item type="input" label="业务单号" name="relate_number"></c-form-item>
					<c-form-item type="input" label="微信支付单号" name="payment_number"></c-form-item>
					<c-form-item type="input" label="会员昵称" name="nick_name"></c-form-item>
					<c-form-item type="input" label="会员手机号" name="user_manage_mobilephone"></c-form-item>
					<c-form-item type="input" label="商家名称" name="company_name"></c-form-item>
					<c-form-item type="datetime" label="生成时间" start-name="begin_time" end-name="end_time"></c-form-item>
					<c-form-item type="checkbox" label="结算状态" name="states" :options="stateOptions" ></c-form-item>
					<c-form-item type="checkbox" label="业务类型" name="order_types" :options="orderTypeOptions" ></c-form-item>
					<c-form-item type="checkbox" label="结算类型" name="reward_types" :options="rewardTypeOptions" ></c-form-item>
				</c-form>
			</m-search>
            <m-operate>
                <c-button color="m" hollow @click="syncExport()">导出</c-button>

                <template #right>
                    <c-button v-if="userInfo.id == 1" color="red" @click="$refs.view.editExportColumn(workType)">编辑导出列</c-button>
                </template>
            </m-operate>
			<c-table ref="table">
				
				<c-table-column
					label="结算流水号"
					name="record_number"
					width="120"
				></c-table-column>
				
				<c-table-column
					label="结算类型 "
					name="reward_type"
					width="100"
				>
					<template v-slot="row">
						{{rewardTypeName[row.data.reward_type]}}
					</template>
				</c-table-column>
				
				<c-table-column
					label="结算对象 "
					name="user_type"
					width="150"
				>
					<template v-slot="row">
						<span v-if="row.data.user_type==1"><span style="color:darkgreen">（代理）</span>{{row.data.nick_name}}</span>
						<span v-if="row.data.user_type==2"><span style="color:#2348d0">（商家）</span>{{row.data.company_name}}</span>
						<span v-if="row.data.user_type==3" style="color:red">（平台）</span>
					</template>
				</c-table-column>

				<c-table-column
					label="业务类型"
					name="order_type"
					width="80"
				>
					<template v-slot="row">
						<span v-if="row.data.order_type==1" style="color:lightsalmon">代理订单</span>
						<span v-else style="color:lightseagreen">销售订单</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="业务单号"
					name="relate_number"
					width="125"
				></c-table-column>

				<c-table-column
					label="支付方式"
					name="payment_type"
					width="80"
				></c-table-column>

				<c-table-column
					label="微信支付单号"
					name="third_number"
					width="230"
				>
                    <template v-slot="row">
                        <span v-if="row.data.payment_type == '微信'">{{row.data.third_number}}</span>
                        <span v-else>-</span>
                    </template>
                </c-table-column>

				<c-table-column
					label="订单总额"
					name="payment_money"
					width="80"
				>
					<template v-slot="row">
					    ¥{{parseFloat(parseFloat(row.data.product_money).toFixed(2))}}
					</template>
				</c-table-column>
				
				<c-table-column
					label="已支付金额"
					name="payment_money"
					width="90"
				>
					<template v-slot="row">
					    <span style="color:green;">¥{{parseFloat(parseFloat(row.data.payment_money).toFixed(2))}}</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="待支付尾款"
					width="90"
				>
					<template v-slot="row">
					    <span v-if="(row.data.product_money-row.data.payment_money) > 0" style="color:red">
							¥{{parseFloat(parseFloat(row.data.product_money-row.data.payment_money).toFixed(2))}}
						</span>
						<span v-else>-</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="可结算金额"
					name="estimated_record_money"
					width="90"
				>
					<template v-slot="row">
					    <span style="color:blue;">¥{{parseFloat(parseFloat(row.data.estimated_record_money).toFixed(2))}}</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="预计最终结算金额"
					name="original_record_money"
					width="130"
				>
					<template v-slot="row">
						<span style="color:gray;">¥{{parseFloat(parseFloat(row.data.original_record_money).toFixed(2))}}</span>
					</template>
				</c-table-column>

				<c-table-column
					label="已结算金额"
					name="record_money"
					width="100"
				>
					<template v-slot="row">
					    <span v-if="row.data.state == 2" style="color:green;">
							¥{{parseFloat(parseFloat(row.data.record_money).toFixed(2))}}
						</span>
						<span v-else>-</span>
					</template>
				</c-table-column>

				<c-table-column
					label="结算状态"
					name="state"
					width="75"
				>
					<template v-slot="{data}">
                        <span v-if="data.state==0" style="color:darkgray">{{transStateName[data.state]}}</span>
                        <span v-if="data.state==1" style="color:#2348d0">{{transStateName[data.state]}}</span>
						<span v-if="data.state==2" style="color:darkgreen">{{transStateName[data.state]}}</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="结算说明"
					name="remark"
					width="270"
				></c-table-column>
				
				<c-table-column
					label="生成时间"
					name="create_date"
					width="140"
				></c-table-column>
				
				<c-table-column
					label="最近更新时间"
					name="update_date"
					width="140"
				></c-table-column>
				
				<c-table-column
					label="取消时间"
					name="cancel_date"
					width="140"
				>
					<template v-slot="{data}">
					    <span v-if="data.cancel_date" style="color:darkgray">{{data.cancel_date}}</span>
					    <span v-else>-</span>
					</template>
				</c-table-column>

				<c-table-column
					type="button"
					fixed="right"
					label="操作"
					width="80"
				>
					<template v-slot="{data}">
						<c-table-button @click="navigateTo(`/reward/detail/${data.relate_number}`)">详情</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</module>
	</page>
</template>

<script>
	import {mapState} from "vuex";

    export default {
		name: 'm_reward_settlement',

        computed: {
            ...mapState(['systemConfig', 'userInfo']),
        },
		data() {
			return {
                workType:2,//业务类型，详见枚举【ExportTypeEnum】
                searchParams:{},
                transStateName: {
                    0: '取消结算',
                    1: '待结算',
                    2: '已结算'
                },
				stateOptions: [
                    {name: '待结算',value: 1},
                    {name: '取消结算',value: 0},
                    {name: '已结算',value: 2}
				],
				rewardTypeName:{
					2: '直推奖励',
					3: '间推奖励',
					201: '爆款代理费',
					202: '专业代理费',
					203: '市代代理费',
					204: '省代代理费',
					205: '业务员代理费',
					206: '平台服务费',
					207: '商家货款'
				},
				orderTypeOptions: [
					{name: '代理订单',value: 1},
					{name: '销售订单',value: 2}
				],
				rewardTypeOptions: [
					{name: '直推奖励',value: 2},
					{name: '间推奖励',value: 3},
					{name: '爆款代理费',value: 201},
					{name: '专业代理费',value: 202},
					{name: '市代代理费',value: 203},
					{name: '省代代理费',value: 204},
					{name: '业务员代理费',value: 205},
					{name: '平台服务费',value: 206},
					{name: '商家货款',value: 207}
				]
			}
		},
		
		mounted() {
			this.$refs.search.search();
		},
		
		methods: {
			searchHandle(data) {
				this.$refs.table.load({
					url: '/reward/record/list',
					data
				});
                this.searchParams = data||{};
            },
            /**
             * 同步导出数据
             * @param work_type
             */
            syncExport(){
                this.request({
                    url: '/export/url',
                    data: Object.assign({
                        work_type: this.workType //业务类型
                    },this.searchParams),
                    success: data => {
                        this.download({
                            fileName: data.filename,
                            url: data.url,
                            loading: {
                                message: '数据文件生成中...'
                            }
                        })
                    }
                });
            }
		}
	}
</script>